
  import { Vue, Component, Prop } from "vue-property-decorator";
  import PopUpContainer from "@/components/common/PopUpContainer.vue";

  @Component({
    components: {
      PopUpContainer,
    },
  })
  export default class PopUpWithActivation extends Vue {
    @Prop({ type: Boolean, default: false }) readonly lightBackground!: boolean;
    @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  }
